module.exports = __webpack_public_path__ + "img/san-jose-hotel-7.ae43596a.jpg";